import { useMemo } from "react";
import { BotActiveTrade } from "@shared/types";
import usePricesSocket from "@shared/services/socket/usePricesSocket";
import { getBotTradeLadder } from "common/NewLook/priceLadder.ts";

const useBotTradeLadder = (
  trade: BotActiveTrade,
  symbol?: string,
  exchange?: string,
  botReverse?: boolean | null
) => {
  const { socketPrice } = usePricesSocket(symbol, exchange);
  return useMemo(
    () =>
      getBotTradeLadder(trade, Number(socketPrice) || undefined, botReverse),
    [trade, socketPrice, botReverse]
  );
};

export default useBotTradeLadder;
